import { EnumSchema } from '../metadata-schema';

export const Kernvak: EnumSchema = {
	"type": "string",
	"title": "Kernvak",
	"enum": [
		"Nederlands",
		"Engels",
		"wiskunde",
		"rekenen",
		"overige vakken"
	]
};
